import { getAppInfo, getAppID } from '@/utils/base'

export const loverflixTemplate = () => {
    return getAppID() === 'loverflix' || getAppID() === 'polarnovel'
}



export default {
    discover_tab: 'สำรวจ',
    mine_tab: 'ของฉัน',
    bookshelf_tab: 'ชั้นหนังสือ',
    ranking: 'อันดับ',
    more: 'เพิ่มเติม',
    search_stories: 'ค้นหาเรื่องราว',
    'you_might_like': 'คุณอาจจะชอบ',
    'chapter': 'บท',
    'chapters': 'บท',
    'completed': 'เสร็จสมบูรณ์',
    'reviews': 'รีวิว',
    'words': 'คำ',
    'summary': 'สรุป',
    'read_now': 'อ่านตอนนี้',
    'add_to_library': 'เพิ่มไปยังไลบรารี',
    'select_payment_method': 'เลือกวิธีการชำระเงิน',
    'most_popular': 'ยอดนิยมที่สุด',
    'weekly': 'รายสัปดาห์',
    'subscribe': 'สมัครสมาชิก',
    'login': 'เข้าสู่ระบบ',
    'register': 'ลงทะเบียน',
    'logout': 'ออกจากระบบ',
    'sign_in_to_get_more': 'เข้าสู่ระบบเพื่อรับเพิ่มเติม',
    'vip_status_inactive': 'สถานะวีไอพี: ไม่ได้ใช้งาน',
    'vip_activated': 'เปิดใช้งานวีไอพีแล้ว',
    'active_wireless_reading_now': 'เปิดใช้งานการอ่านแบบไร้สายตอนนี้',
    'question': 'ศูนย์ช่วยเหลือ',
    'terms_of_service': 'ข้อกำหนดการให้บริการ',
    'privacy_policy': 'นโยบายความเป็นส่วนตัว',
    'search': 'ค้นหา',
    'user': 'ผู้ใช้',
    'password': 'รหัสผ่าน',
    'by_continuing_you_agree_with_the': 'การดำเนินการต่อหมายถึงคุณยอมรับ ',
    'and': 'และ',
    'username_or_password_cannot_be_empty': 'ชื่อผู้ใช้หรือรหัสผ่านไม่สามารถเว้นว่างได้',
    'username_or_password_length_must_be_greater_than_8': 'ความยาวชื่อผู้ใช้หรือรหัสผ่านต้องมากกว่า 8 ตัวอักษร',
    'register_success': 'ลงทะเบียนสำเร็จ',
    'login_success': 'เข้าสู่ระบบสำเร็จ',
    'logout_success': 'ออกจากระบบสำเร็จ',
    'rules': 'กฎ',
    'vip_member_benefits': 'สิทธิประโยชน์สมาชิกวีไอพี',
    'bookshelf_none': 'ยังไม่มีหนังสือบนชั้นหนังสือ ไปที่ร้านค้าเพื่อเลือกหนังสือที่คุณชอบ',
    'go_to_the_bookstore': 'ไปที่ร้านค้า',
    'search_none': 'ดูเหมือนว่าคุณยังไม่เคยทำการซื้อมาก่อน',
    'go_to_pay': 'คุณจะถูกนำไปยังหน้าชำระเงินในเร็วๆ นี้',
    'continue': 'ดำเนินการต่อ',
    'PRIVACY': {
        content: `
                <h1>นโยบายความเป็นส่วนตัวของ Lambnovel</h1>
                <section>
                    <h2>ยินดีต้อนรับสู่นโยบายความเป็นส่วนตัวของ Lambnovel</h2>
                    <p>เมื่อคุณใช้แอปพลิเคชันและบริการของ Lambnovel นั่นหมายความว่าคุณเชื่อมั่นในวิธีการที่เราดำเนินการกับข้อมูลของคุณ นโยบายความเป็นส่วนตัวนี้มีขึ้นเพื่อช่วยให้คุณเข้าใจว่าเรารวบรวมข้อมูลใดบ้าง ทำไมเราจึงรวบรวมข้อมูลนั้น และข้อมูลจะถูกนำไปใช้อย่างไร การทำความเข้าใจแนวปฏิบัติของเรานั้นมีความสำคัญ ดังนั้นเราจึงหวังว่าคุณจะสละเวลาอ่านนโยบายฉบับนี้</p>
                </section>

                <section>
                    <h2>เกี่ยวกับนโยบายความเป็นส่วนตัวของเรา</h2>
                    <p>นโยบายความเป็นส่วนตัวของเราอธิบายประเด็นต่อไปนี้:</p>
                    <ul>
                    <li>- ข้อมูลใดที่เรารวบรวม และเหตุใดเราจึงรวบรวม</li>
                    <li>- ข้อมูลจะถูกนำไปใช้อย่างไร</li>
                    </ul>
                </section>

                <section>
                    <h2>ข้อมูลที่เรารวบรวม</h2>
                    <p>เพื่อให้บริการที่ดีขึ้นแก่ผู้ใช้ทุกคน เราอาจรวบรวมข้อมูลจากคุณเพื่อวัตถุประสงค์ที่ถูกกฎหมาย รวมถึงข้อมูลพื้นฐานบางอย่างที่สามารถอนุมานได้ (เช่น ภาษาที่คุณใช้) ตลอดจนข้อมูลที่ซับซ้อนมากขึ้น (เช่น ความชอบในการอ่านของคุณ)</p>

                    <h3>เรารวบรวมข้อมูลอย่างไร:</h3>
                    <ul>
                    <li>
                        <p>ข้อมูลที่คุณให้แก่เรา: ตัวอย่างเช่น เพื่อดาวน์โหลดหนังสือของเรา หรือใช้บริการโซเชียล คุณจะต้องลงทะเบียนบัญชี Lambnovel เมื่อลงทะเบียน เราจะขอให้คุณให้ข้อมูลพื้นฐานบางอย่าง เช่น หมายเลขโทรศัพท์ของคุณ หรือบัญชีโซเชียลที่คุณอนุญาตให้เราลิงก์ไปถึง (เช่น บัญชี Google+, บัญชี Facebook เป็นต้น) ข้อมูลเหล่านี้จะถูกเก็บไว้ภายใต้บัญชีของคุณ และเรามีการตั้งค่าเพื่อเชื่อมโยงกับบัญชีโซเชียลเหล่านี้ใน Lambnovel</p>
                    </li>
                    <li>
                        <p> ข้อมูลที่ได้รับระหว่างการใช้บริการของเรา: เราจะรวบรวมข้อมูลเกี่ยวกับบริการที่คุณใช้และวิธีที่คุณใช้บริการเหล่านั้น เช่น ไม่ว่าคุณจะเรียกดูร้านค้าออนไลน์หรือไม่ และคุณใช้เวลาอ่านหนังสือประเภทใดมากขึ้น ข้อมูลเหล่านี้รวมถึง:</p>
                        <ul>
                        <li>ข้อมูลอุปกรณ์: เราอาจรวบรวมข้อมูลอุปกรณ์ (เช่น รุ่นฮาร์ดแวร์ รหัสประจำตัวอุปกรณ์เฉพาะ และข้อมูลเครือข่ายมือถือ)</li>
                        <li>ข้อมูลตำแหน่ง: เมื่อคุณใช้ Lambnovel เราอาจรวบรวมและประมวลผลข้อมูลเกี่ยวกับตำแหน่งที่ตั้งจริงของคุณ เราจะใช้เทคนิคต่างๆ ในการระบุตำแหน่ง รวมถึงที่อยู่ IP และ GPS</li>
                        <li>ข้อมูลการอ่าน: เมื่อคุณใช้ Lambnovel เราจะรวบรวมข้อมูลการอ่านของคุณ (เช่น หมายเหตุของคุณ ประวัติการเรียกดู และประวัติการดูตัวอย่างหนังสือ เป็นต้น)</li>
                        </ul>
                    </li>
                    </ul>
                </section>

                <section>
                    <h2>เราใช้ข้อมูลที่รวบรวมได้อย่างไร</h2>
                    <p>เราจะใช้ข้อมูลที่รวบรวมได้จากบริการทั้งหมดเพื่อให้บริการ บำรุงรักษา ปกป้อง และปรับปรุงบริการเหล่านั้น พร้อมทั้งพัฒนาบริการใหม่ๆ และรักษาความมั่นคงปลอดภัยของข้อมูล นอกจากนี้เรายังจะใช้ข้อมูลประเภทนี้เพื่อให้เนื้อหาที่เหมาะกับคุณ เช่น ประเภทหนังสือที่มีความสัมพันธ์สูง</p>
                    <p>เราจะใช้ข้อมูลอุปกรณ์ที่รวบรวมได้เพื่อจับคู่บัญชี Lambnovel เริ่มต้นสำหรับคุณ เพื่อให้คุณสามารถใช้ผลิตภัณฑ์ของเราและเรียกดูร้านค้าออนไลน์ได้โดยเร็วที่สุด</p>
                    <p>ข้อมูลตำแหน่งถูกใช้เพื่อเพิ่มความเพลิดเพลินทางสังคมของผลิตภัณฑ์ คุณสามารถค้นหาผู้อ่านที่คล้ายคลึงกันได้ใน "ผู้คนใกล้ๆ ฉัน" ข้อมูลบัญชีของคุณจะถูกเก็บไว้บนระบบคลาวด์ของเรา ดังนั้นคุณสามารถเข้าสู่ระบบและซิงค์บันทึกการอ่านของคุณด้วยบัญชีเดียวได้ตลอดเวลา</p>
                </section>

                <section>
                    <h2>ข้อมูลที่คุณแบ่งปัน</h2>
                    <p>เรามีบริการแบ่งปันทางโซเชียลที่น่าสนใจบางส่วน เช่น การแบ่งปันหนังสือและการแบ่งปันรายการอ่าน เราจะไม่บันทึกข้อมูลการแบ่งปันเหล่านี้ คุณจำเป็นต้องดูแลความปลอดภัยของข้อมูลของคุณเมื่อใช้บริการเหล่านี้</p>
                </section>

                <section>
                    <h2>ดูและอัปเดตข้อมูลส่วนบุคคลของคุณ</h2>
                    <p>เมื่อใดก็ตามที่คุณใช้บริการของเรา เราจะพยายามทำให้แน่ใจว่าคุณสามารถเข้าถึงข้อมูลส่วนบุคคลของคุณได้อย่างเต็มที่ หากข้อมูลเหล่านี้ไม่ถูกต้อง เราจะพยายามอย่างเต็มที่เพื่อหาวิธีต่างๆ ที่ช่วยให้คุณสามารถอัปเดตหรือลบข้อมูลได้อย่างรวดเร็ว (เว้นแต่จะต้องเก็บข้อมูลเหล่านี้ไว้เพื่อความจำเป็นทางธุรกิจที่ชอบด้วยกฎหมายหรือเพื่อวัตถุประสงค์ทางกฎหมาย) เมื่อคุณอัปเดตข้อมูลส่วนบุคคลของคุณ เราอาจขอให้คุณยืนยันตัวตนก่อนดำเนินการตามคำขอของคุณ</p>
                    <p>สำหรับคำขอที่ซ้ำซ้อนไม่มีที่สิ้นสุด ต้องใช้วิธีการทางเทคนิคมากเกินไป เสี่ยงต่อความเป็นส่วนตัวของผู้อื่น หรือไม่สามารถปฏิบัติได้จริง (เช่น ข้อมูลที่จัดเก็บบนเทปสำรอง) เราอาจปฏิเสธ</p>
                    <p>ตราบใดที่เราอนุญาตให้คุณเข้าถึงและแก้ไขข้อมูล และไม่ต้องการข้อมูลเพิ่มเติมมากเกินไป เราจะให้บริการนั้นฟรี เราจะพยายามปรับปรุงการบำรุงรักษาบริการเพื่อปกป้องข้อมูลของคุณจากความเสียหายโดยบังเอิญหรือความเสียหายจากเจตนาร้าย ดังนั้นเมื่อคุณลบข้อมูลออกจากบริการของเรา เราอาจไม่ได้ลบสำเนาข้อมูลที่เหลืออยู่ออกจากเซิร์ฟเวอร์ที่ใช้งานอยู่ และอาจไม่ได้ลบข้อมูลที่สอดคล้องกันออกจากระบบสำรองข้อมูล</p>
                </section>

                <section>
                    <h2>การลบข้อมูลของคุณ</h2>
                    <p>คุณสามารถร้องขอให้ลบข้อมูลของคุณได้ตลอดเวลาโดยติดต่อเราที่ ops@novellettes.com เราจะประเมินคำขอดังกล่าวเป็นกรณีไป เราอาจเก็บข้อมูลของคุณบางส่วนไว้ตราบเท่าที่จำเป็นอย่างสมเหตุสมผลสำหรับผลประโยชน์ทางธุรกิจที่ชอบด้วยกฎหมายของเรา รวมถึงการตรวจจับและป้องกันการฉ้อโกง และเพื่อปฏิบัติตามภาระผูกพันทางกฎหมายของเรารวมถึงภาษี การรายงานทางกฎหมาย และภาระผูกพันในการตรวจสอบ บางครั้งคำขอของคุณจะสำเร็จได้ก็ต่อเมื่อปิดบัญชีของคุณ</p>
                    <p>คุณมีความสามารถในการลบบัญชีของคุณ และคุณควรเข้าใจว่าเมื่อลบบัญชีของคุณแล้ว คุณจะสูญเสียสิทธิ์ในการเข้าถึงหรือใช้แพลตฟอร์มทั้งหมดหรือบางส่วน</p>
                </section>

                <section>
                    <h2>การอนุญาตใช้ผลิตภัณฑ์n</h2>
                    <p>เพื่อให้คุณสมบัติที่ค่อนข้างดีบางประการ เราต้องการให้คุณอนุญาตให้เราใช้ทรัพยากรระบบของคุณเมื่อติดตั้ง Lambnovel การอนุญาตและการใช้งานเหล่านี้มีดังนี้:</p>
                    <ul>
                    <li>สื่อและไฟล์: Lambnovel จำเป็นต้องใช้พื้นที่เก็บข้อมูลบนมือถือส่วนหนึ่งเพื่อบันทึกหนังสือที่ดาวน์โหลด</li>
                    <li>กล้อง: Lambnovel มีฟังก์ชัน "สแกน" ซึ่งสามารถค้นหาได้อย่างรวดเร็วว่าหนังสือที่คุณชอบมีเวอร์ชันอิเล็กทรอนิกส์ในร้าน Lambnovel หรือไม่</li>
                    <li>ข้อมูลการเชื่อมต่อ WLAN: เมื่อคุณใช้ WLAN เราจะแนะนำให้คุณดาวน์โหลดปลั๊กอินบางตัวที่มีขนาดค่อนข้างใหญ่</li>
                    <li>รหัสอุปกรณ์ (Device ID): รหัสอุปกรณ์เป็นพารามิเตอร์สำคัญที่เราสามารถใช้เพื่อเริ่มต้นบัญชี Lambnovel แบบผู้ใช้ชั่วคราวสำหรับคุณ</li>
                    </ul>
                </section>

                <section>
                    <h2>การบังคับใช้นโยบายความเป็นส่วนตัว</h2>
                    <p>นโยบายความเป็นส่วนตัวนี้ใช้กับ lambnovel.com สำหรับบริษัทและองค์กรอื่นๆ ที่โฆษณาบริการของเราและอาจใช้คุกกี้ แท็กพิกเซล และเทคโนโลยีอื่นๆ ในการดำเนินการและให้บริการโฆษณาที่เกี่ยวข้อง นโยบายความเป็นส่วนตัวของเราไม่ครอบคลุมถึงแนวปฏิบัติในการประมวลผลข้อมูลของพวกเขา</p>
                </section>
                <h3>ข้อตกลงนี้อยู่ภายใต้กฎหมายของเขตบริหารพิเศษฮ่องกงแห่งสาธารณรัฐประชาชนจีน</h3>
        `
    },
    SERVICE: {
        content: `
           <h1>ข้อกำหนดการให้บริการ</h1>
    <p>ยินดีต้อนรับสู่ Lambnovel!</p>
    <p>ข้อตกลงการให้บริการ Lambnovel ฉบับนี้ (ต่อไปนี้เรียกว่า "ข้อตกลง") ได้ถูกจัดทำขึ้นระหว่าง Kynix Group Limited (ที่อยู่: RM 10D R1, 10/F KIN GA IND BLDG 9 SAN ON ST TUEN MUN HONG KONG) (ต่อไปนี้เรียกว่า "ผู้ให้บริการ") กับผู้ใช้ Lambnovel (ต่อไปนี้เรียกว่า "ผู้ใช้") ซึ่งเกี่ยวข้องกับการติดตั้ง การใช้ และเรื่องอื่นๆ ที่เกี่ยวข้องกับแอปพลิเคชัน "Lambnovel" (ต่อไปนี้เรียกว่า "Lambnovel") การคลิก "ฉันยอมรับ" หรือวิธีอื่นใดเพื่อยอมรับข้อตกลงนี้ แสดงว่าท่านรับทราบว่าท่านได้บรรลุข้อตกลงกับ Lambnovel แล้ว และยอมรับข้อกำหนดและเงื่อนไขทั้งหมดต่อไปนี้</p>

    <h2>ข้อ 1 บริการสำหรับผู้ใช้</h2>
    <p>ผู้ใช้ต้อง (i) อ่านและยอมรับข้อตกลงนี้ให้ครบถ้วนก่อนการติดตั้ง ทำซ้ำ ดาวน์โหลด เยี่ยมชม หรือใช้ Lambnovel ในวิธีใดๆ ก็ตาม (ii) ดาวน์โหลด Lambnovel จากเว็บไซต์หรือสื่อที่ผู้ให้บริการกำหนดเท่านั้น ผู้ให้บริการไม่มีภาระหน้าที่หรือความรับผิดใดๆ ต่อความเสี่ยงและ/หรือความเสียหายใดๆ ที่อาจเกิดขึ้นจากความผิดของผู้ใช้ตามข้อตกลงนี้</p>

    <h2>ข้อ 2 ทรัพย์สินทางปัญญา</h2>
    <h3>2.1</h3>
    <p>ผู้ให้บริการเป็นเจ้าของลิขสิทธิ์ของ Lambnovel สิทธิในทรัพย์สินทางปัญญาทั้งหมดของ Lambnovel ตลอดจนเนื้อหาข้อมูลที่เกี่ยวข้องกับ Lambnovel รวมถึงแต่ไม่จำกัดเพียง การแสดงข้อความและการจัดรวมกันของข้อความ ไอคอน การตกแต่งกราฟิก รูปภาพ แผนภูมิ สี การออกแบบอินเทอร์เฟซ โครงร่างเลย์เอาต์ ข้อมูลที่เกี่ยวข้อง โปรแกรมเพิ่มเติม วัสดุสิ่งพิมพ์หรือเอกสารอิเล็กทรอนิกส์ ฯลฯ ได้รับการคุ้มครองภายใต้กฎหมายลิขสิทธิ์ และสนธิสัญญาลิขสิทธิ์ระหว่างประเทศ ตลอดจนกฎหมายและระเบียบข้อบังคับอื่นๆ เกี่ยวกับทรัพย์สินทางปัญญา ผู้ใช้ต้องไม่แยกส่วน ดีคอมไพล์ หรือดิสแอสเซมเบิล Lambnovel โดยไม่ได้รับการอนุมัติเป็นลายลักษณ์อักษรล่วงหน้าจากผู้ให้บริการ</p>

    <h3>2.2</h3>
    <p>ผู้ใช้รับทราบว่าข้อความ รูปภาพ วัสดุกราฟิกใดๆ ของบริการเครือข่ายที่ผู้ให้บริการให้มา ได้รับการคุ้มครองภายใต้กฎหมายลิขสิทธิ์ เครื่องหมายการค้า และ/หรือกฎหมายความเป็นเจ้าของทรัพย์สินอื่นๆ โดยไม่ได้รับการอนุมัติเป็นลายลักษณ์อักษรล่วงหน้าจากผู้ให้บริการ ข้อมูลข้างต้นต้องไม่ถูก (i) เผยแพร่หรือเล่นทางสื่อใดๆ โดยตรงหรือโดยอ้อม (ii) เขียนใหม่หรือเผยแพร่ซ้ำเพื่อวัตถุประสงค์ในการเผยแพร่หรือเล่น (iii) ใช้เพื่อวัตถุประสงค์ทางการค้าอื่นใด ข้อมูลทั้งหมดหรือบางส่วนจะสามารถใช้ได้เฉพาะเพื่อวัตถุประสงค์ส่วนตัวและไม่ใช่เชิงพาณิชย์เท่านั้น เพื่อบันทึกไว้ในอุปกรณ์ปลายทางของผู้ใช้ ผู้ให้บริการไม่มีภาระหน้าที่หรือความรับผิดต่อผู้ใช้หรือบุคคลที่สามใดๆ สำหรับความเสียหายและ/หรือความสูญเสียใดๆ ที่เกิดจาก (i) ความล่าช้า ความไม่ถูกต้อง ความผิดพลาด การละเลยของข้อมูล (ii) ในระหว่างการส่งหรือการยื่นข้อมูลหรือส่วนใดส่วน hereof</p>

    <h2>ข้อ 3 การชำระเงิน</h2>
    <h3>3.1</h3>
    <p>ค่าบริการอินเทอร์เน็ตอาจเกิดขึ้นและถูกเรียกเก็บโดยผู้ให้บริการเครือข่ายมือถือระหว่างการดาวน์โหลดและการใช้ Lambnovel ผู้ใช้ควรสอบถามรายละเอียดจากผู้ให้บริการเครือข่ายมือถือในพื้นที่</p>

    <h3>3.2</h3>
    <p>Lambnovel จัดหาหนังสือที่ได้รับอนุญาตจากเจ้าของลิขสิทธิ์ ผู้ใช้อาจถูกเรียกเก็บเงินขณะอ่านหนังสือหรือเนื้อหาบางส่วน Lambnovel จะแจ้งเตือนผู้ใช้อย่างเฉพาะเจาะจงก่อนการเรียกเก็บเงิน ผู้ใช้กด "ยกเลิก" หรือ "กลับ" เพื่อยกเลิก และผู้ให้บริการจะไม่เรียกเก็บค่าธรรมเนียมใดๆ</p>

    <h3>3.3</h3>
    <p>Lambnovel ยอมรับการชำระเงินรวมถึงแต่ไม่จำกัดเพียง Google Wallet เป็นต้น ผู้ใช้จะถือว่าได้ยอมรับวิธีการชำระเงินของ Lambnovel แล้ว เมื่อยอมรับข้อตกลงนี้</p>

    <h2>ข้อ 4 ข้อผูกพันของผู้ใช้</h2>
    <h3>4.1</h3>
    <p>ผู้ใช้แสดงและรับรองว่าจะใช้ Lambnovel (i) อย่างถูกกฎหมายและสุจริต (ii) โดยไม่ละเมิดสิทธิและผลประโยชน์ที่ชอบด้วยกฎหมายของบุคคลที่สามใดๆ</p>

    <h3>4.2</h3>
    <p>ผู้ใช้แสดงและรับรองว่าจะไม่ลบ เปลี่ยนแปลง เพิ่มฟังก์ชันหรือข้อมูลที่บันทึกไว้ในแอปพลิเคชันด้วยความมุ่งร้าย หรือจงใจหลีกเลี่ยงหรือทำลายมาตรการทางเทคนิคของผู้ให้บริการเพื่อการคุ้มครองลิขสิทธิ์ของ Lambnovel ผู้ใช้ต้องรับความเสี่ยงและความรับผิดทั้งหมดที่เกิดจากการละเมิดข้อกำหนดนี้ ในกรณีที่ผู้ใช้มีส่วนทำให้ Lambnovel เกี่ยวข้องกับกิจกรรมที่ผิดกฎหมายหรือละเมิดวัตถุประสงค์ของข้อตกลงนี้ ผู้ให้บริการมีสิทธิ์ที่จะหยุดให้บริการแก่ผู้ใช้ทันที และสงวนสิทธิ์ในการสอบสวนและระบุความรับผิดของผู้ใช้ผ่านช่องทางทางตุลาการ</p>

    <h3>4.3</h3>
    <p>ผู้ใช้แสดงและรับรองว่าจะไม่ (i) เลียนแบบผลิตภัณฑ์และบริการของผู้ให้บริการเพื่อวัตถุประสงค์ทางการค้า (ii) คัดลอกหรือเลียนแบบปรัชญาการออกแบบ อินเทอร์เฟซ ฟังก์ชัน และแผนภูมิของผู้ให้บริการ หรือ (iii) ดัดแปลงหรือสร้างผลิตภัณฑ์อื่นที่ได้มาจาก Lambnovel โดยไม่ได้รับการอนุมัติเป็นลายลักษณ์อักษรล่วงหน้าจากผู้ให้บริการ</p>

    <h3>4.4</h3>
    <p>ผู้ใช้ต้องไม่ใช้ Lambnovel หรือบริการของตนเพื่อสร้าง อัปโหลด คัดลอก ส่ง แบ่งปันเนื้อหาที่ละเมิดกฎหมายที่ใช้บังคับ</p>

    <h3>4.5</h3>
    <p>ผู้ใช้ต้องรับผิดชอบในการชดใช้ค่าเสียหายทั้งหมดต่อผู้ให้บริการและ/หรือความสูญเสียของผู้อื่นที่เกิดจากการละเมิดข้อตกลงนี้ หากผู้ให้บริการต้องรับผิดดังกล่าว ผู้ใช้จะต้องชดใช้ค่าใช้จ่ายและความสูญเสียที่เกี่ยวข้องของผู้ให้บริการ รวมถึงค่าทนายความที่สมเหตุสมผล</p>

    <h3>4.6</h3>
    <p>ผู้ใช้รับทราบว่าการละเมิดข้อแสดงและการรับรองใดๆ ข้างต้น หรือกฎและ/หรือประกาศของผู้ให้บริการ อาจส่งผลให้การใช้งาน Lambnovel ของผู้ใช้ถูกระงับทันทีโดยไม่มีการคืนเงินหรือแจ้งให้ทราบล่วงหน้า</p>

    <h3>4.7</h3>
    <p>ผู้ใช้ยอมรับที่จะรับบริการข้อมูลทั้งหมดที่ผู้ให้บริการจัดหาในขณะที่ใช้ Lambnovel</p>

    <h2>ข้อ 5 สิทธิและข้อผูกพัน</h2>
    <h3>5.1</h3>
    <p>ผู้ให้บริการมีสิทธิ์ที่จะแก้ไขและอัปเดต Lambnovel เมื่อใดก็ได้ตามความต้องการของการดำเนินงานและสภาพแวดล้อมเครือข่าย</p>

    <h3>5.2</h3>
    <p>ในกรณีที่ผู้ใช้ละเมิดข้อตกลงนี้ขณะใช้ Lambnovel และก่อให้เกิดความเสียหายต่อผู้ให้บริการ ผู้ให้บริการมีสิทธิ์ที่จะ採取มาตรการต่างๆ รวมถึงแต่ไม่จำกัดเพียง การหยุดใบอนุญาตและบริการ จำกัดการใช้งาน สอบสวนและกำหนดความรับผิดทางกฎหมาย เป็นต้น</p>

    <h3>5.3</h3>
    <p>ผู้ให้บริการอาจ ดำเนินการตามดุลยพินิจแต่เพียงผู้เดียว หยุดให้บริการ Lambnovel เมื่อใดก็ได้โดยไม่ต้องรับผิดและ/หรือแจ้งให้ผู้ใช้ทราบ</p>

    <h2>ข้อ 6 ข้อจำกัดความรับผิดและการปฏิเสธความรับผิด</h2>
    <p>ผู้ใช้รับทราบว่าผู้ให้บริการจะไม่รับผิดต่อเงื่อนไขต่อไปนี้ รวมถึงแต่ไม่จำกัดเพียง:</p>

    <h3>6.1</h3>
    <p>ปัญหาระบบที่เกิดจากพายุเฮอริเคน แผ่นดินไหว สึนามิ น้ำท่วม ไฟฟ้าดับ สงคราม การโจมตีของผู้ก่อการร้าย ฯลฯ ("เหตุสุดวิสัย")</p>

    <h3>6.2</h3>
    <p>ปัญหาบริการที่เกิดจากการโจมตีของแฮกเกอร์ การปรับเปลี่ยนทางเทคนิคหรือความล้มเหลวของแผนกโทรคมนาคม การอัปเดตเว็บไซต์ ปัญหาของธนาคาร ฯลฯ</p>

    <h3>6.3</h3>
    <p>ผู้ให้บริการไม่รับรองว่า (i) Lambnovel ไม่มีข้อบกพร่องทางเทคนิค (ii) ผู้ให้บริการแก้ไขข้อบกพร่องทั้งหมดของ Lambnovel (iii) Lambnovel ตอบสนองความต้องการทั้งหมดของผู้ใช้</p>

    <h3>6.4</h3>
    <p>ทางออกเดียวสำหรับความไม่พอใจต่อข้อตกลงนี้หรือ Lambnovel คือการหยุดใช้ Lambnovel</p>

    <h3>6.5</h3>
    <p>ผู้ใช้ตกลงว่าข้อตกลงนี้อยู่ภายใต้ และข้อพิพาทใดๆ ที่เกิดจากหรือเกี่ยวข้องกับข้อตกลงนี้ จะต้องมีการเจรจาระหว่างผู้ให้บริการและผู้ใช้ด้วยความสุจริตใจ อย่างไรก็ตาม หากข้อพิพาทไม่สามารถแก้ไขได้ ทั้งสองฝ่ายตกลงที่จะส่งข้อพิพาทไปยังศาลเขตที่ตั้งของผู้ให้บริการเพื่อการอนุญาโตตุลาการ</p>

    <h3>6.6</h3>
    <p>ข้อกำหนดใดๆ ของข้อตกลงนี้ ไม่ว่าเพราะเหตุใด ถือเป็นโมฆะทั้งหมดหรือบางส่วน หรือบังคับใช้ไม่ได้ หรือละเมิดกฎหมายที่ใช้บังคับใดๆ ให้ถือว่าข้อกำหนดนั้นถูกลบออก ข้อกำหนดอื่นๆ ของข้อตกลงนี้ยังคงมีผลใช้บังคับและมีผลผูกพัน</p>

    <h2>ข้อ 7 กฎการให้บริการต่ออายุอัตโนมัติ</h2>
    <p>การสมัครใช้ เปิดใช้งาน และใช้บริการต่ออายุอัตโนมัติสำหรับสมาชิก Lambnovel (ต่อไปนี้เรียกรวมกันว่า "บริการต่ออายุอัตโนมัติ") ถือว่าท่านยอมรับกฎเหล่านี้</p>
    <p>ท่านเข้าใจและตกลงว่า:</p>

    <h3>7.1</h3>
    <p>หากท่านเปิดใช้บริการต่ออายุอัตโนมัตินี้ และไม่ได้ยกเลิกบริการต่ออายุอัตโนมัตินี้อย่างชัดแจ้งในช่วงระยะเวลาสมาชิก หน่วยงานที่เกี่ยวข้องจะหักเงินยอดคงเหลือจากบัญชีเติมเงินของท่านเอง บัญชีชำระเงินบุคคลที่สามที่ผูกไว้ บัตรธนาคาร บัญชีการสื่อสาร ฯลฯ (ต่อไปนี้เรียกรวมกันว่า "บัญชี") โดยอัตโนมัติ ณ เวลาหนึ่งวันก่อนวันหมดอายุของแต่ละระยะเวลาสมาชิก ค่าบริการสำหรับระยะเวลาสมาชิกถัดไปจะถูกหักจากยอดคงเหลือในบัญชีของท่านโดยอัตโนมัติ เพื่อขยายระยะเวลาการใช้งานของระยะเวลาสมาชิกที่เกี่ยวข้อง ท่านควรใส่ใจกับสถานะของบัญชีและยอดเงินที่หักได้ดังกล่าวข้างต้น และท่านจะรับความเสี่ยงและ/หรือความสูญเสียเนื่องจากปัญหาบัญชีหรือยอดเงินไม่เพียงพอซึ่งทำให้การต่ออายุล้มเหลว</p>

    <h3>7.2</h3>
    <p>ระยะเวลาสมาชิก: หนึ่งสัปดาห์ หนึ่งปี ฯลฯ (ขึ้นอยู่กับคำอธิบายบนหน้าสมัครสมาชิก) สมาชิกสามารถเลือกได้ด้วยตนเอง</p>

    <h3>7.3</h3>
    <p>Lambnovel สามารถเสนอการทดลองใช้ฟรีให้กับผู้สมัครใช้บริการแบบเสียค่าบริการรายใหม่ หากท่านซื้อการสมัครใช้บริการแบบเสียค่าบริการที่มีการทดลองใช้ฟรี ท่านจะสามารถใช้บริการแบบเสียค่าบริการได้ฟรีในช่วงระยะเวลาทดลองใช้ฟรี เมื่อสิ้นสุดระยะเวลาทดลองใช้ฟรีที่ applicable ท่านจะถูกเรียกเก็บค่าธรรมเนียมสมาชิก และจะถูกเรียกเก็บเงินต่อไปจนกว่าท่านจะยกเลิกการสมัครใช้ของท่าน เพื่อหลีกเลี่ยงการเกิดค่าใช้จ่ายใดๆ ท่านต้องยกเลิกก่อนสิ้นสุดระยะเวลาทดลองใช้ฟรี</p>

    <h3>7.4</h3>
    <p>ท่านรับทราบและตกลงว่า Lambnovel มีสิทธิ์ในการปรับเปลี่ยนราคาของบริการ หาก Lambnovel ตั้งใจจะปรับราคาบริการหลังจากที่ท่านเปิดใช้บริการต่ออายุอัตโนมัติแล้ว Lambnovel จะแจ้งให้ท่านทราบล่วงหน้าด้วยวิธีการที่เหมาะสม (รวมถึงแต่ไม่จำกัดเพียง การประกาศในแอปพลิเคชัน เอสเอ็มเอส ฯลฯ) หากท่านไม่เห็นด้วยกับการปรับราคาบริการ ท่านสามารถยกเลิกบริการต่ออายุอัตโนมัตินี้ตามกฎเหล่านี้ หากท่านไม่ยกเลิกบริการต่ออายุอัตโนมัตินี้ ค่าบริการครั้งต่อๆ ไปที่หน่วยงานที่เกี่ยวข้องหัก จะอิงตามค่าบริการที่ปรับแล้ว หากท่านยกเลิกภายใน 24 ชั่วโมงก่อนการหมดอายุของระยะเวลาสมาชิก หน่วยงานที่เกี่ยวข้องอาจหยุดหักค่าบริการสำหรับระยะเวลาสมาชิกถัดไปตามค่าบริการที่ปรับแล้ว หลังจากยกเลิกบริการต่ออายุอัตโนมัตินี้แล้ว หากท่านเปิดใช้บริการต่ออายุอัตโนมัติอีกครั้ง ค่าบริการที่หน่วยงานที่เกี่ยวข้องหักโดยอัตโนมัติจะต้องอิงตามค่าบริการที่แสดงบนหน้าในเวลานั้น</p>

    <h3>7.5</h3>
    <p>วิธีการยกเลิกการสมัครสำหรับผู้ใช้บริการต่ออายุอัตโนมัติ มีดังนี้</p>
    <p>หากท่านได้ซื้อการสมัครใช้บริการแบบเสียค่าบริการสำหรับการต่ออายุอัตโนมัติ ท่านสามารถยกเลิกการสมัครใช้ได้ทุกเวลาก่อนสิ้นสุดรอบการเรียกเก็บเงินปัจจุบัน และการยกเลิกจะมีผลในรอบการเรียกเก็บเงินถัดไป ท่านจะยังคงสามารถเข้าถึงบริการแบบเสียค่าบริการได้ตั้งแต่วันที่ยกเลิกจนถึงวันเริ่มต้นรอบการเรียกเก็บเงินถัดไป</p>
    <p>การชำระเงินผ่าน Apple IAP (การซื้อในแอป): เปิด "การตั้งค่า" บนอุปกรณ์ iOS ของท่าน --> ไปที่ "iTunes Store และ App Store" --> คลิก "Apple ID" เลือก "ดู Apple ID" เข้าสู่หน้า "การตั้งค่าบัญชี" คลิก "การสมัครใช้งาน" และเลือกสมาชิก Lambnovel เพื่อยกเลิกการสมัครใช้ หากท่านไม่ยกเลิกคุณสมบัติการต่ออายุอัตโนมัติ 1 วันก่อนที่ระยะเวลาสมาชิกจะหมดอายุ การสมัครใช้จะถูกต่ออายุและหักเงินโดยอัตโนมัติ</p>
    <p>Google Play Store: ไปที่ google play --> คลิก "การตั้งค่า" --> คลิก "การสมัครใช้งาน" และเลือกสมาชิก Lambnovel เพื่อยกเลิกการสมัครใช้ของท่าน หากท่านไม่ยกเลิกฟังก์ชันการต่ออายุอัตโนมัติ 1 วันก่อนที่ระยะเวลาสมาชิกจะหมดอายุ การสมัครใช้จะถูกต่ออายุและหักเงินโดยอัตโนมัติ</p>

    <h3>7.6</h3>
    <p>Lambnovel อาจหยุดให้บริการต่ออายุอัตโนมัติแก่ท่านตามกลยุทธ์การดำเนินงานของตนด้วย และสมาชิก Lambnovel ของท่านจะสิ้นสุดตั้งแต่วันที่หมดอายุของระยะเวลาบริการปัจจุบัน</p>

    <h2>ข้อ 8 เนื้อหาที่เกี่ยวข้อง</h2>
    <p>เพื่อให้มั่นใจว่า Lambnovel ยังคงเป็นแพลตฟอร์มที่ปลอดภัยและอารยะ เราได้พัฒนามาตรฐานชุดหนึ่งเพื่อกำหนดเนื้อหาที่เป็นอันตรายหรือไม่เหมาะสมสำหรับผู้ใช้ และห้ามไม่ให้เนื้อหาดังกล่าวปรากฏบนแพลตฟอร์มของเรา</p>
    <p>CSAM/CSEM: หากหนังสือมีเนื้อหาการล่วงละเมิดเด็ก เราจะลบออกจาก Lambnovel ทันที ซึ่งรวมถึงเนื้อหาการล่วงละเมิดทางเพศเด็กทั้งหมด</p>
    <p>การข่มขืน: เราไม่อนุญาตให้หนังสือใดๆ มีเนื้อหาทางเพศโดยใช้กำลังหรือการกลั่นแกล้งโดยใช้กำลัง</p>
    <p>การร่วมประเวณีระหว่างญาติ: เราไม่อนุญาตให้หนังสือใดๆ มีเนื้อหาที่บ่อนทำลายจริยธรรมของมนุษย์และบรรทัดฐานทางสังคม ความสัมพันธ์ทางเพศที่ไม่เหมาะสมระหว่างญาติ</p>
    <p>การมีเพศสัมพันธ์กับสัตว์: เราไม่อนุญาตให้หนังสือใดๆ มีการแสดงทางเพศระหว่างมนุษย์กับสัตว์ป่า</p>
    <p>สำหรับประเด็นดังกล่าว เราจะดำเนินการตรวจสอบเนื้อหาอย่างต่อเนื่อง เมื่อค้นพบ เราจะลบเนื้อหาทันที และแบนผู้เขียนหนังสือดังกล่าวจากการเผยแพร่เนื้อหาของตนบนแพลตฟอร์มอย่างถาวร หากท่านมีคำถามใดๆ เกี่ยวกับหนังสือที่เราจัดหา โปรดติดต่อเรา: ops@novellettes.com</p>

    <p>ข้อตกลงนี้อยู่ภายใต้กฎหมายของเขตบริหารพิเศษฮ่องกงแห่งสาธารณรัฐประชาชนจีน</p>
        
        `
    },
    ABOUT: {
        content: `
            <section>
                <p>หากต้องการยกเลิกบริการสมาชิก สามารถดำเนินการได้โดยวิธีต่อไปนี้:  </p>
                <p>
                    ส่งอีเมลถึง ops@novellettes.com พร้อมระบุอีเมลบัญชีที่ใช้ชำระเงินและวันที่เริ่มใช้บริการ  
                </p>
                <p>
                    หากมีข้อสงสัยประการใด โปรดติดต่อเราผ่านอีเมล เราจะตอบกลับภายใน 24 ชั่วโมง
                </p>
               
            </section>
        `
    },
    AGREEMENT: {
        content: `
            <section>
                <h1>Clockwise Subscription Agreement</h1>
                <h3>Last Updated: [01.20.2025]</h3>
                <h3>1. Subscription Services</h3>
                <p>
                This Subscription Agreement ("Agreement") governs your access to [Novellettes] ("Service") provided by [ CLOCKWISE INTERNATIONAL (HONG KONG) LIMITED] ("Company," "we," or "us"). By subscribing, you ("User," "you") agree to be bound by these terms.
                </p>
                <h3>
                2. Subscription Plans & Auto-Renewal
                </h3>
                <p>
                Subscription Tiers:
                </p>
                <p>
                All subscription levels are subject to the actual payment page.
                </p>
                <p>
                First week discount, subsequent deductions will be based on the original price.
                </p>
                <p>
                Auto-Renewal:
                </p>
                <p>
                Subscription are automatically charged each billing period, whether weekly or another period, and you may be charged no more than 24 hours before the beginning of each billing period until you cancel your subscription.
                </p>
                <p>You authorize recurring charges to your designated payment method through Payermax until cancellation.</p>
                <h3>3. Payment Terms & No Free Trial</h3>
                <p>No Free Trial: The Service begins immediately upon payment confirmation. No free trial period is offered.</p>
                <p>Payment Processing:</p>
                <p>All fees are processed securely via Payermax. You agree to maintain valid and updated payment information.</p>
                <p>Prices are subject to change with 30 days’ notice. Continued use after notice constitutes acceptance.</p>
                <p>Non-Refundable Payments: All fees are final and non-refundable unless otherwise required by applicable law.</p>
                <h3>4. Cancellation & Refund Requests</h3>
                <p>Cancellation: To prevent auto-renewal, you must cancel your subscription through your account settings or email service@novellettes.com at least [1 days] before the next billing cycle.</p>
                <p>Refunds:</p>
                <p>Refund requests must be submitted via email to service@novellettes.com.</p>
                <p>Refunds are granted only if mandated by law (e.g., consumer protection regulations).</p>
                <h3>5. User Responsibilities</h3>
                <p>Ensure all account and billing information is accurate and current.</p>
                <p>Do not share accounts, reverse-engineer, or misuse the Service.</p>
                <h3>6. Termination</h3>
                <p>We reserve the right to suspend or terminate your subscription without prior notice for violations of this Agreement, fraudulent activity, or failure to pay fees.</p>
                <h3>7. Disclaimer & Liability</h3>
                <p>"As Is" Service: The Service is provided without warranties of any kind, express or implied.</p>
                <p>Limitation of Liability: We are not liable for indirect, incidental, or consequential damages arising from your use of the Service.</p>
                <h3>8. Governing Law & Amendments</h3>
                <p>Governing Law: This Agreement is governed by the laws of [HongKong].</p>
                <p>Updates: We may modify these terms with 30 days’ advance notice (via email or in-app notification). Continued use constitutes acceptance.</p>
                <h3>Acknowledgment</h3>
                <p>By subscribing, you confirm that you have read, understood, and agreed to this Agreement.</p>
            </section>
        
        `
    },
    'VIP_INTEREST': {
        1: `อ่านหนังสือระดับพรีเมียมกว่า 10,000 เล่มได้ฟรีแบบไม่จำกัด  `,
        2: 'อัปเดตหนังสือใหม่กว่า 200 เล่มทุกสัปดาห์  ',
        3: 'สัมผัสประสบการณ์อ่านแบบไม่มีโฆษณารบกวน'
    },
    'VIP_RULES': {
        content: `
            <p> ราคา: ส่วนลดในสัปดาห์แรก การหักเงินครั้งถัดไปจะคิดตามราคาปกติ</p>
            <p>• กฎการอ่าน: ผู้ที่ไม่ได้สมัครสมาชิกสามารถอ่านบทฟรีได้</p>
            <p>• การชำระเงิน: ระบบจะเรียกเก็บเงินผ่านบัญชีแอปสโตร์ของคุณ</p>
            <p>• การต่ออายุ: การสมัครสมาชิกของคุณจะต่ออายุอัตโนมัติ</p>
            <p>• ระบบจะเรียกเก็บเงินในแต่ละรอบบิลโดยอัตโนมัติ (รายสัปดาห์หรือรอบอื่น) และอาจมีการเรียกเก็บเงินล่วงหน้าไม่เกิน 24 ชั่วโมงก่อนเริ่มรอบบิลใหม่ จนกว่าคุณจะยกเลิกการสมัครสมาชิก</p>
            <p>• การยกเลิก: คุณสามารถยกเลิกการสมัครสมาชิกได้ทุกเวลา โดยต้องยกเลิกก่อนวันต่ออายุอย่างน้อย 24 ชั่วโมง</p>
            <p>• จัดการการสมัครสมาชิก: คุณสามารถดู เปลี่ยนแปลง หรือยกเลิกการสมัครสมาชิกได้ผ่านการตั้งค่าบัญชี</p>
        
        `
    }
}